<template>
  <div id="EditProfilePage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid third-bg py-10">
        <div class="container-md">
          <div class="row">
            <div class="col-12 text-center">
              <h1>
                <span class="font-19 border-bottom-gold px-5">  اطلاعات فردی</span>
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <v-form ref="profile">
                <div class="row">
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fa-duotone fa-user ml-2"></i> نام :</div>
                    <v-text-field
                        v-model="firstName"
                        class=" mb-1"
                        dense
                        flat
                        solo></v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fa-duotone fa-user ml-2"></i>نام خانوادگی:</div>
                    <v-text-field
                        v-model="lastName"
                        class=" mb-1"
                        dense
                        flat
                        solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fas fa-keyboard ml-2"></i>پسورد:</div>
                    <v-text-field
                        v-model="Password"
                        class=" mb-1"
                        dense
                        flat
                        placeholder="رمزعبور"
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fas fa-keyboard ml-2"></i>تکرار پسورد:</div>
                    <v-text-field
                        v-model="ConfirmPassword"
                        class=" mb-1"
                        dense
                        flat
                        placeholder="رمزعبور"
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fa-duotone fa-mobile-button ml-2"></i>موبایل:</div>
                    <v-text-field
                        v-model="mobile"
                        class=" mb-1"
                        dense
                        flat
                        placeholder="رمزعبور"
                        readonly
                        solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fa-duotone fa-envelope ml-2"></i>ایمیل:</div>
                    <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        class=" mb-1"
                        dense
                        flat
                        placeholder="رمزعبور"
                        solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-4"><i class="primary-text fa-duotone fa-id-card  ml-2"></i>کدملی:</div>
                    <v-text-field
                        v-model="nationalCode"
                        :rules="nationalCodeRules"
                        class=" mb-1"
                        dense
                        flat
                        placeholder="رمزعبور"
                        solo
                        type="number">
                    </v-text-field>
                  </div>
                  <div class="col-12 col-md-9 mx-auto">
                    <!--                <v-btn :disabled="email === null || email.length < 0  " block color="secondary" rounded @click="editProfile">-->
                    <v-btn block color="primary" elevation="0" rounded @click="editProfile">
                      ویرایش
                    </v-btn>
                  </div>
                </div>
              </v-form>
            </div>

          </div>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "EditProfile",
  metaInfo: {
    title: 'آموزش املاک-  اطلاعات فردی ',
  },
  components: {FooterComponent, NavBar},
  data: () => ({
    isFormValid: false,
    showResultDialog: false,
    showLoaderDialog: false,
    dialogResult: null,
    lastName: '',
    userName: '',
    firstName: '',
    ConfirmPassword: '',
    Password: '',
    FileUrl: '',
    mobile: '',
    nationalCode: '',
    TypeRole: '',
    email: '',
    ID: '',
    ImageFileUrl: '',
    VeriyMobileCode: '',
    VeriyEmailCode: '',
    IsActive: false,
    SmsNotification: false,
    PushNotification: false,
    EmailNotification: false,
    nationalCodeRules: [
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    emailRules: [
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (pattern.test(v) || !v) || 'ایمیل نامعتبر'
      },
    ],

  }),
  mounted() {
    this.getData()
  },
  methods: {
    editProfile() {
      this.$refs.profile.validate()
      if (this.$refs.profile.validate()) {
        let resStatus = null
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("UserName", this.userName);
        formdata.append("Email", this.email);
        formdata.append("Password", this.Password);
        formdata.append("ConfirmPassword", this.ConfirmPassword);
        formdata.append("Name", this.firstName);
        formdata.append("Family", this.lastName);
        formdata.append("NationalCode", this.nationalCode);
        formdata.append("FileUrl", this.FileUrl);
        formdata.append("ImageFileUrl", this.ImageFileUrl);
        formdata.append("PhoneNumber", this.mobile);
        formdata.append("IsActive", this.IsActive);
        formdata.append("VeriyMobileCode", this.VeriyMobileCode);
        formdata.append("VeriyEmailCode", this.VeriyEmailCode);
        formdata.append("SmsNotification", this.SmsNotification);
        formdata.append("PushNotification", this.PushNotification);
        formdata.append("EmailNotification", this.EmailNotification);
        formdata.append("ID", this.ID);
        formdata.append("TypeRole", this.TypeRole);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/EditUser", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200){

                this.dialogResult = result
                this.showResultDialog = true
                this.getData()
              }
              else {
                this.dialogResult = result
                this.showResultDialog = true
              }

            })
            .catch(error => console.log('error', error));
      }
    },
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/EditUser", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.Name !== null) {
              this.firstName = json.Name
            }
            if (json.Family !== null) {
              this.lastName = json.Family
            }
            if (json.PhoneNumber !== null) {
              this.mobile = json.PhoneNumber
            }
            if (json.Email !== null) {
              this.email = json.Email
            }
            if (json.NationalCode !== null) {
              this.nationalCode = json.NationalCode
            }
            this.userName = json.UserName
            this.ID = json.ID
            this.Password = json.Password
            this.ConfirmPassword = json.ConfirmPassword
            this.TypeRole = json.TypeRole
            this.FileUrl = json.FileUrl
            this.ImageFileUrl = json.ImageFileUrl
            this.IsActive = json.IsActive
            this.VeriyMobileCode = json.VeriyMobileCode
            this.VeriyEmailCode = json.VeriyEmailCode
            this.SmsNotification = json.SmsNotification
            this.PushNotification = json.PushNotification
            this.EmailNotification = json.EmailNotification
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
